import {
  IPaycodeListParams,
  IPaycodePage,
  IPaycodeAddParams,
  IPOSTerminalListParams,
  IPOSTerminalItem,
  IPOSTerminalAddParams,
  IEasyPayParams,
  IEasyPayItem,
  IEasyPayCreateParams,

} from '../../types/terminal-management/collect';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl, isNull } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 收款码列表
 */
export async function queryPayCodePageList(param: IPaycodeListParams) {
  let data = [] as IPaycodePage[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IPaycodeListParams;

  try {
    const { code, context, message } = await Http.post<{ data: IPaycodePage[]; total: number }>(`${hostUrl}/pay/yop/pay-code/page`, param);

    console.log(context);
    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IPaycodePage[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 修改收款码状态
 */
export async function changePayCodeStatus(param: {payCodeId: number;status: number}) {

  param = JSON.parse(JSON.stringify(param)) as {payCodeId: number;status: number};

  try {
    const { code, message } = await Http.put<any>(`${hostUrl}/pay/yop/pay-code/status`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 获取所属公司
 */
export async function getAllCompanyList(bussinessId?: number) {

  let data = [];

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/side/company/list`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };

}

/**
 * 门店列表(包含子公司)
 */
export async function queryStoreSubList(params: {companyId?: string}) {
  let data = [];

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/pay/yop/store/list-sub`, params);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 员工列表(包含子公司)
 */
export async function queryStaffSubList(params: {storeId: number}) {
  let data = [];

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/pay/yop/staff/list-sub`, params);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [];

    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 新增收款码
 */
export async function addPaycode(param: IPaycodeAddParams) {

  param = JSON.parse(JSON.stringify(param)) as IPaycodeAddParams;
  param.amountSplitThreshold = Number(param.amountSplitThreshold);

  if (param.amountSplitStrategy === 'NO_SPLIT' || isNull(param.amountSplitStrategy)) {
    param.amountSplitThreshold = undefined;
  }

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/yop/pay-code`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 新增收款码
 */
export async function editPaycode(param: IPaycodeAddParams) {

  param = JSON.parse(JSON.stringify(param)) as IPaycodeAddParams;
  param.amountSplitThreshold = Number(param.amountSplitThreshold);

  if (param.amountSplitStrategy === 'NO_SPLIT' || isNull(param.amountSplitStrategy)) {
    param.amountSplitThreshold = undefined;
  }

  try {
    const { code, message } = await Http.put<any>(`${hostUrl}/pay/yop/pay-code`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 查看收款码详情
 */
export async function queryPayCodeDetail(params: {payCodeNo: string}) {
  let data = {} as IPaycodePage;

  try {
    const { code, context, message } = await Http.get<any>(`${hostUrl}/pay/yop/pay-code/detail`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as IPaycodePage;

      data = res || {} as IPaycodePage;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * POS终端分页列表
 */
export async function queryPOSTerminalPage(param: IPOSTerminalListParams) {
  let data = [] as IPOSTerminalItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IPOSTerminalListParams;

  try {
    const { code, context, message } = await Http.post<{ data: IPOSTerminalItem[]; total: number }>(`${hostUrl}/pay/pos-terminal/page-query`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IPOSTerminalItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 新增POS终端
 */
export async function addPOSTerminal(param: IPOSTerminalAddParams) {

  param = JSON.parse(JSON.stringify(param)) as IPOSTerminalAddParams;

  try {
    const { code, message } = await Http.post<IPOSTerminalItem>(`${hostUrl}/pay/pos-terminal/create`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 修改POS终端信息
 */
export async function editPOSTerminal(param: IPOSTerminalAddParams) {

  param = JSON.parse(JSON.stringify(param)) as IPOSTerminalAddParams;

  try {
    const { code, message } = await Http.post<IPOSTerminalItem>(`${hostUrl}/pay/pos-terminal/modify`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 移除POS终端
 */
export async function deletePOSTermina(id: number) {

  try {
    const { code, message } = await Http.delete<void>(`${hostUrl}/pay/pos-terminal/${id}`);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 易缴费 - 分页page
 */
export async function queryEasyPayPage(param: IEasyPayParams) {
  let data = [] as IEasyPayItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IEasyPayParams;

  try {
    const { code, context, message } = await Http.post<{ data: IEasyPayItem[]; total: number }>(`${hostUrl}/pay/easy-pay/page-query`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IEasyPayItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 易缴费 - 创建更新收款
 */
export async function addEasyPay(param: IEasyPayCreateParams) {

  param = JSON.parse(JSON.stringify(param)) as IEasyPayCreateParams;

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/easy-pay/create-or-update`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 易缴费 - 修改状态
 */
export async function editEasyPayStatus(param: {id: number;status: string}) {

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/easy-pay/change-status`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 易缴费 - 详情
 */
export async function queryEasyPayDetail(id: number) {
  let data = {} as IEasyPayItem;

  try {
    const { code, context, message } = await Http.get<IEasyPayItem>(`${hostUrl}/pay/easy-pay/detail/${id}`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IEasyPayItem;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 易缴费 - 解析易缴费二维码重新生成
 */
export async function parseEasyPayQr(params: {qrUrl: string}) {
  let data = { qrUrl: '' };

  try {
    const { code, context, message } = await Http.post<{qrUrl: string}>(`${hostUrl}/pay/easy-pay/regenerate-qr`, params);

    if (code === EAxiosResponseCode.Succeed) {
      return context || data;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

